import { type JSX } from "react";
import { CheckmarkCircleRegular, OpenRegular } from "@fluentui/react-icons";
import { resolveLaunchUrl } from "@/utils/launch-url";

export interface DealTrackerConfirmationProps {
  /** Sub-line under the heading, e.g. "3 deals updated". */
  detail: string;
  /** Deep-link target; falls back to the dashboard when the URL is not configured. */
  taskId: number;
  onDone: () => void;
}

/**
 * Shared close-out for both save paths (TAD-6037 / TAD-6038). "Open in TRIYO"
 * lands on the tracker task itself, carrying the SSO session (TAD-6039).
 */
export function DealTrackerConfirmation({ detail, taskId, onDone }: DealTrackerConfirmationProps): JSX.Element {
  const trackerUrl = resolveLaunchUrl(`tasks/edit/std/${taskId}`);

  return (
    <div className="deal-tracker__confirmation" role="status">
      <CheckmarkCircleRegular className="deal-tracker__confirmation-icon" />
      <h3>Deal Tracker updated</h3>
      <p>{detail}</p>
      <div className="deal-tracker__confirmation-actions">
        <button type="button" className="deal-tracker__primary-button" onClick={onDone}>
          Done
        </button>
        {trackerUrl ? (
          <a href={trackerUrl} target="_blank" rel="noreferrer" className="deal-tracker__secondary-button">
            Open in TRIYO <OpenRegular />
          </a>
        ) : null}
      </div>
    </div>
  );
}
